// extracted by mini-css-extract-plugin
module.exports = {"posts":"postlist-module--posts--2kmDk","center":"postlist-module--center--3kEXt"};